<!-- 
  この画面が開かれるパターンは4つある。
  一つ目 アカウントを持っていない=匿名認証した状態で開いた場合
        → アカウントの作成画面に遷移
  二つ目 アカウントを持っている=匿名認証した状態で開いた場合
        → ホーム画面に遷移
  三つ目 古いLINEでのアカウントを持っている=匿名認証した状態で開いた場合
        → アカウントの作成画面に遷移するが、旧LINEでログインするボタンを表示しておく
  四つ目 LINEではないアカウントを持っている=通常の認証をした状態で開いた場合
        → トーストを表示し、ホーム画面に遷移
  五つ目 既にログインしている状態で開いた場合
        → トーストを表示し、ホーム画面に遷移
-->

<template>
  <div
  >
    <div v-if="isLoading">
      <v-progress-linear
        indeterminate
        color="#008CFF"
      ></v-progress-linear>
      <p
        class="h2 loading-text"
      >
        読み込み中です。<br><span class="fadein">少々お待ちください。</span>
      </p>
    </div>
    <div v-if="!isLoading">
      <div v-if="mode!='replace'&&oldLineExists">
        <!-- 元々LINEを使ってみんスタオンラインを使っていた方はこちらのボタンから再度認証をお願いします。という文章とlineButtonコンポーネントを表示する -->
        <v-card
          class="mx-8 my-8 rounded-xl card flex flex-col justify-center items-center"
          color="white"
          elevation="1"
          outlined
          style="border:medium solid #707070;"
        >
          <p class="m-3 text-h6 text-center">元々LINEを使ってみんスタオンラインを使っていた方はこちらのボタンから再度認証をお願いします。</p>
          <line-button mode="replace" />
        </v-card>
      </div>
      <v-card
        class="rounded-xl card flex flex-col justify-center items-center"
        color="white"
        elevation="1"
        outlined
        style="border:medium solid #707070;"
      >
        <v-card-actions class="mb-0">
          <v-col class="flex">
              <p class="m-3 text-center">LINEアカウントでのログインに成功しました<br/>Liqlid内で表示させる名前を設定してください</p>
              <p class="mb-0 name-font">ハンドルネームを設定</p>
              <v-form v-model="valid">
                <v-row>
                  <v-col
                    class="name"
                  >
                    <v-text-field
                      v-model="handlename"
                      :rules="nameRules"
                      :counter="handleNameLength"
                      placeholder="ハンドルネームを入力"
                      required
                      width="50"
                      onsubmit="return false;"
                      onkeydown="if(event.keyCode==13){return false;}"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-card
                class="mx-auto"
                color="#dff2e1"
                max-width="344"
                outlined
                style="border-radius: 10px;"
              >
                <v-list-item class="justify-center font-weight-bold">
                  ログイン中のLINEアカウント
                </v-list-item>
                <v-list-item
                  style="background-color: #fff; border-radius: 10px; margin: 0px 10px 10px"
                >
                  <v-list-item-avatar size="50">
                    <img
                      alt="..."
                      :src="this.picture"
                    >
                  </v-list-item-avatar>
                  <v-list-item-title class="body-1">
                      {{this.name}}
                  </v-list-item-title>
                </v-list-item>
              </v-card>
              <div class="">
                <a target="_blank" rel="noopener" href="https://liquitous.com/terms-and-privacy">利用規約</a>、
                <a target="_blank" rel="noopener" href="https://liquitous.com/terms-and-privacy">プライバシーポリシー</a>、
                <a target="_blank" rel="noopener" href="https://liquitous.com/terms-and-privacy">ガイドライン</a>
                <v-checkbox
                  class="checkbox"
                  v-model="checkbox"
                  label="上記の規約に同意します"
                  style="padding-left: 0%;"
                ></v-checkbox>
                <!--reseterr(),submit()-->
              </div>
          </v-col>
  
        </v-card-actions>
        <v-row class="px-10 pb-8" justify="space-between">
          <v-card-actions>
            <v-btn
              large
              :disabled="!checkbox||!handlename||handlename.length>handleNameLength||isSubmitting"
              class="signupbtn"
              color="#008cff"
              @click="submit()"
              style="text-transform: none; font-family: mplus-2c-bold; border-width:3px;"
              outlined
            >
              確認してはじめる
              <v-progress-circular
                v-if="isSubmitting"
                indeterminate
                color="#008cff"
                size="25"
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </div>
  </div>
</template>
<script>

import lineButton from '../components/auth/parts/lineButton.vue'
import Vue from 'vue'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
export default {
  components: {
    lineButton,
  },
  data () {
    return {
      checkbox: false,
      handlename: '',
      handleNameLength: Number(process.env.VUE_APP_VALUE_NAME_LENGTH || '20'),
      nameRules: [
        v => !!v || '名前を入力してください',
        v => v.length <= this.handleNameLength || `${this.handleNameLength}文字以下で入力してください`,
      ],
      code: this.$route.query.code,
      state: this.$route.query.state,
      mode: this.$route.query.mode,
      oldLineExists: !!process.env.VUE_APP_LINE_CLIENT_ID_OLD,
      name: '読み込み中...',
      picture: '',
      token: '',
      isLoading: true,
      isSubmitting: false,
      show1: false,
      valid: false,
    }
  },
  created: async function() {
    this.handleLogin()
    // 15秒待って、まだ読み込み中ならエラー
    setTimeout(() => {
      if (this.isLoading) {
        console.error('too long time at line login')
        alert('読み込みに時間がかかっており、ログインに失敗した可能性があります。もう一度やり直してください。')
        this.redirect()
      }
    }, 15000)
  },
  methods: {
    async handleLogin() {
      const data = await this.$store.dispatch('auth/linkOauth', {provider: 'line', code: this.code, state: this.state, mode: this.mode})
      if (!data.success) {
        if (data.accountExists && data.merged) {
          console.error('account with line already exists. stopping merge.')
          alert('あなたのLINEが紐づいたアカウントが既に存在します。そのアカウントでログインし直してください。')
        } else {
          const message = data.error || 'ログインに失敗しました。もう一度やり直してください。'
          console.error(message)
          alert(message)
        }
        this.isLoading = false;
        this.redirect()
      } else if (data.makeSignUp) {
        this.name = data.name;
        this.picture = data.picture;
        if (this.mode == "replace") {
          this.state = data?.state;
          this.showToast("新しくアカウントを作成してください。")
        }
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.redirect()
      }
    },
    async submit(){
      this.isSubmitting = true
      const data = await this.$store.dispatch('auth/signUpOauth', {provider: 'line', state: this.state, name: this.handlename})
      if (data.success) {
        this.redirect()
      } else {
        alert('ログインに失敗しました。もう一度やり直してください。')
        this.redirect()
      }
    },
    redirect() {
      const toPath = localStorage.getItem('pathBeforeLINE')
      if (toPath && !toPath.startsWith('/signup') && !toPath.startsWith('/hvvtnegu') && !toPath.startsWith('/lineauthhandle')) {
        localStorage.removeItem('pathBeforeLINE')
        this.$router.push(toPath)
      } else {
        this.$router.push('/')
      }
    },
    showToast(message="完了しました"){
      this.$toasted.success(message, {
        theme: "bubble", 
        position: "top-center", 
        duration : 5000,
      });
    },
  },
}
</script>
<style scoped>
@keyframes fade {
  0% { opacity: 0; }
  100% { opacity: 1; }
};
.loading-text {
  animation: fade 1s ease-in-out 0s 1 normal forwards;
  margin-top: 1rem;
  text-align: center;
  font-size: 1.5rem;
}
.fadein {
  animation: fade 1s ease-in-out 2s 1 normal forwards;
}
</style>